<template>
    <div>
        <app-template>
            <facturation-list-table />
        </app-template>>
    </div>
</template>

<script>
import FacturationListTable from './FacturationListTable.vue';
    export default {
        components: {
            FacturationListTable
        }
    }
</script>

<style lang="scss" scoped>

</style>